













import { Component, Vue } from 'vue-property-decorator'
import { goToSet, goToFeedback } from '@/utils/h5ToApp'
import { isTourist, goToLogin } from '@/utils/util'
@Component
export default class topServe extends Vue {
  isTourist = isTourist
  goToLogin = goToLogin

  goToSet() {
    if (isTourist()) {
      goToLogin()
      return false
    }
    goToSet()
  }

  goToFeedBack() {
    if (isTourist()) {
      goToLogin()
      return false
    }
    goToFeedback()
  }

  handleMessage () {
    if (isTourist()) {
      goToLogin()
      return false
    }
  }
}
